<template>
  <div class="w-100 flex justify-center mb-12">
    <div class="grid grid-cols-2 gap-y-16 gap-x-16">
      <frame-component
        v-for="(pics, index) in splitPictures"
        :key="index"
        :pictures="pics"
      ></frame-component>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, toRefs } from 'vue';
import FrameComponent from './Frame.component.vue';

export default defineComponent({
  name: 'Gallery-component',
  components: { FrameComponent },
  props: {
    pictures: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
  },
  setup(props) {
    const gallerySize = 6;
    let refProps = toRefs(props);
    let allPictures = refProps;
    let splitPictures = [],
      i,
      len;

    for (i = 0, len = allPictures.pictures.value.length; i < len; i += gallerySize) {
      const pics = allPictures.pictures.value.slice(i, i + gallerySize);
      if (pics.length === 6) splitPictures.push(pics);
    }

    return { splitPictures };
  },
});
</script>
